<template>
    <div class="logos">
        <img
            v-for="logo in logos"
            :key="logo.alt"
            :src="logo.src"
            :alt="logo.alt"
        />
    </div>
</template>

<script>
import fenix from "../../../images/companies-logos/fenix.png";
import menora from "../../../images/companies-logos/menora.png";
import harel from "../../../images/companies-logos/harel.png";
import clal from "../../../images/companies-logos/clal.png";
import aig from "../../../images/companies-logos/aig.png";
export default {
    data() {
        return {
            logos: [
                {
                    src: fenix,
                    alt: "fenix"
                },
                {
                    src: menora,
                    alt: "menora"
                },
                {
                    src: harel,
                    alt: "harel"
                },
                {
                    src: clal,
                    alt: "clal"
                },
                {
                    src: aig,
                    alt: "aig"
                }
            ]
        };
    }
};
</script>

<style lang="scss" scoped>
.logos {
    display: flex;
    justify-content: space-between;
    width: 60%;
    margin: 0 20px;
}
</style>
